import type { PerformanceBand, PerformanceBandConfig } from "../types/supplier-performance.types";

export const PERFORMANCE_BANDS: PerformanceBandConfig[] = [
	{
		band: "red",
		label: "Low",
		min: 1,
		max: 2,
		color: "text-red-600",
		bgColor: "bg-red-100",
	},
	{
		band: "amber",
		label: "Moderate",
		min: 3,
		max: 5,
		color: "text-amber-600",
		bgColor: "bg-amber-100",
	},
	{
		band: "blue",
		label: "Strong",
		min: 6,
		max: 7,
		color: "text-blue-600",
		bgColor: "bg-blue-100",
	},
	{
		band: "green",
		label: "Exemplary",
		min: 8,
		max: 9,
		color: "text-green-600",
		bgColor: "bg-green-100",
	},
];

export const BAND_COLORS: Record<PerformanceBand, string> = {
	red: "#EF4444",
	amber: "#F59E0B",
	blue: "#3B82F6",
	green: "#22C55E",
};

export const getBandForScore = (score: number | null): PerformanceBand | null => {
	if (score === null || score === undefined) {
		return null;
	}

	const rounded = Math.round(score);
	const config = PERFORMANCE_BANDS.find(
		(band) => rounded >= band.min && rounded <= band.max
	);
	return config?.band ?? null;
};

export const getBandConfig = (band: PerformanceBand): PerformanceBandConfig => {
	const config = PERFORMANCE_BANDS.find((b) => b.band === band);
	if (!config) {
		return PERFORMANCE_BANDS[0];
	}
	return config;
};

export const getBandConfigForScore = (score: number | null): PerformanceBandConfig | null => {
	const band = getBandForScore(score);
	if (!band) {
		return null;
	}
	return getBandConfig(band);
};
